import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IGridUIState } from '../../types';
import type { IState } from '../store';

/**
 * Updates the projects overview grid UI state (column state, column group state, filter model)
 * in memory only. Unlike setProjectsOverviewGridUIState, this does not persist to the server —
 * that only happens when the user explicitly clicks "Save View".
 */
export const setProjectsOverviewGridUIStateLocal = createAsyncThunk<
  void,
  { gridUIState: IGridUIState },
  { state: IState }
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- state update happens in the slice's extraReducers, keyed off action.meta.arg
>('uiView/setProjectsOverviewGridUIStateLocal', () => {});
